/**
 * Sweet little script for loading the component files automagically
 */

// Define contexts to require
const contexts = [require.context("./", false, /\.vue$/)];

// Define components
const layouts = [];
contexts.forEach((context) => {
	context.keys().forEach((key) => layouts.push(context(key).default));
});

// Install the above defined forms
const Layouts = {
	install(Vue) {
		layouts.forEach((layout) => {
			Vue.component(layout.name, layout);
		});
	}
};

// Finally export as default
export default Layouts;
